<template>
  <v-card elevation="15">
    <v-card-title>
      <span class="text-h5">Solicita presupuesto sin compromiso</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="nombre"
              label="Nombre*"
              required
              :error-messages="errores.nombre"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="email"
              label="Email*"
              type="email"
              required
              :error-messages="errores.email"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="telefono"
              label="Teléfono*"
              required
              :error-messages="errores.telefono"
              @input="validarTelefono"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="mensaje"
              label="Cuentanos en que podemos ayudarte"
              required
              :error-messages="errores.mensaje"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>
      <small>*Nos pondremos en contacto a la mayor brevedad posible.</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="enviarFormulario">Enviar</v-btn>
    </v-card-actions>
    <v-alert v-if="mensajeConfirmacion" type="success">{{ mensajeConfirmacion }}</v-alert>
    <v-card-text v-if="!mensajeConfirmacion">
      <v-container v-if="!formularioEnviado">
        <v-row>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import emailServer from '@/config/emailServer';

export default {
  data: () => ({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: '',
    mensajeConfirmacion: '',
    errorEnvio: '',
    errores: {
      nombre: '',
      email: '',
      telefono: '',
      mensaje: '',
    },
    formularioEnviado: false,
  }),
  methods: {
    async enviarFormulario() {
      if (!this.validarFormulario()) {
        console.log("Formulario vacío");
        return;
      }

      const formData = new FormData();
      formData.append('name', this.nombre);
      formData.append('email', this.email);
      formData.append('phone', this.telefono);
      formData.append('message', this.mensaje);

      try {
        await emailServer.sendEmail(formData);
       
      } catch (error) {
        this.errorEnvio = 'Error al enviar el formulario';
      }
      this.mensajeConfirmacion = 'Formulario enviado con éxito';
        this.formularioEnviado = true;
        this.limpiarFormulario()
    },
    validarTelefono() {
      const telefonoRegex = /^\d{9}$/;
      return telefonoRegex.test(this.telefono);
    },
    validarFormulario() {
      this.resetErrores();

      let valido = true;

      if (!this.nombre) {
        this.errores.nombre = 'El nombre es obligatorio';
        valido = false;
      }

      if (!this.email || !this.validarEmail(this.email)) {
        this.errores.email = 'Ingrese un email válido';
        valido = false;
      }

      if (!this.telefono || !this.validarTelefono()) {
        this.errores.telefono = 'Ingrese un número de teléfono válido';
        valido = false;
      }

      if (!this.mensaje) {
        this.errores.mensaje = 'El mensaje es obligatorio';
        valido = false;
      }

      return valido;
    },
    validarEmail(email) {
      const emailRegex = /\S+@\S+\.\S+/;
      return emailRegex.test(email);
    },
    limpiarFormulario() {
      this.nombre = '';
      this.email = '';
      this.telefono = '';
      this.mensaje = '';
      this.resetErrores();
    },
    resetErrores() {
      this.errores.nombre = '';
      this.errores.email = '';
      this.errores.telefono = '';
      this.errores.mensaje = '';
    },
  },
};
</script>
